import React from "react";
import styles from "../styles/Footer.module.css"

const Footer = () => {
  return (
    <div className={styles.container}>
<p>Designed and coded with love by Katrina Rossi ♡</p>
</div>
  )
};

export default Footer;